<template>
  <transition
    enter-active-class="transition duration-200 ease-out"
    enter-from-class="-translate-y-1 opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition duration-150 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="-translate-y-1 opacity-0">
    <div
      v-if="isActive"
      class="absolute inset-x-0 top-0 py-6 px-4 bg-white shadow-lg z-[999] ring-1 ring-gray-900/5 flex flex-col gap-6 justify-center items-center rounded-t-lg">
      <slot name="content">
        <p>
          {{ $t('messages.unsavedChanges') }}
        </p>
      </slot>
      <div class="flex items-center justify-center w-full gap-3">
        <BaseButton @click="emit('cancel')">{{
          cancelText ? cancelText : $t('messages.continueEdit')
        }}</BaseButton>
        <BaseButton outline @click="emit('confirm')">{{
          confirmText ? confirmText : $t('messages.dismissChanges')
        }}</BaseButton>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import BaseButton from './BaseButton.vue';

defineProps<{
  isActive: boolean;
  cancelText?: string;
  confirmText?: string;
}>();

const emit = defineEmits(['confirm', 'cancel']);
</script>
